// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Sub Tab Component */
/**
 * Base Styles/Mixins for Ids Sub Tabs Component and all subcomponents.
 */
/**
 * Single Checkmark Mixin
 */
/**
 * Checkbox Mixins.
 */
@keyframes check {
  0% {
    height: 0;
    left: 0;
    top: 8px;
    width: 0;
  }
  50% {
    height: 0;
    left: 0;
    top: 8px;
    width: 4px;
  }
  100% {
    height: 10px;
    left: 4px;
    top: 0;
    width: 4px;
  }
}
@keyframes checkindeterminate {
  0% {
    width: 0;
  }
  100% {
    width: 10px;
  }
}
/**
 * NOTE ABOUT MENU ITEM ELEMENT ORDER:
 * Definitions for grid template size in IdsMenuItem are defined based on the below order.
 * If changes are made to IdsMenuItem's rendering, this order must remain in place.
 *
 * [checkmark?] - [icon?] - text - [shortcut text?] - [submenu icon?]
 **/
:host {
  display: block;
  position: static;
}
:host ::slotted(ids-menu) {
  display: none;
}

:host(.ids-tab-more-menu-item) div a .ids-sub-tab-text {
  text-overflow: unset;
  overflow: visible;
}

::slotted(ids-text) {
  pointer-events: none;
}

::slotted(ids-icon[icon=close]) {
  inset-block-start: 1px;
}

::slotted(ids-popup-menu) {
  position: static;
}

:host([hidden]) {
  display: none;
}

.ids-sub-tab {
  align-items: center;
  cursor: pointer;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  list-style: none;
  position: static;
  transition: background-color 50ms cubic-bezier(0.4, 0, 0.6, 1);
  user-select: none;
}
.ids-sub-tab.dismissible {
  display: flex;
}
.ids-sub-tab.dismissible a {
  width: calc(100% - 32px);
}
.ids-sub-tab ids-icon,
.ids-sub-tab .ids-icon,
.ids-sub-tab .ids-sub-tab-display-icon {
  display: block;
  align-self: center;
  justify-content: center;
  place-self: inherit;
}
.ids-sub-tab a {
  padding-inline-start: 12px;
  padding-inline-end: var(--ids-space-xs);
  padding-block: var(--ids-menu-item-padding);
  display: grid;
  font-size: var(--ids-menu-item-font-size);
  grid-template-columns: 0 auto;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: inherit;
  white-space: nowrap;
}
.ids-sub-tab a:focus {
  outline: 0;
}
.ids-sub-tab a > * {
  vertical-align: middle;
}
.ids-sub-tab a .ids-sub-tab-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ids-sub-tab a ids-icon,
.ids-sub-tab a .ids-icon,
.ids-sub-tab a .ids-sub-tab-display-icon {
  grid-column-start: 1;
}
.ids-sub-tab a .ids-sub-tab-text {
  grid-column-start: 2;
}
.ids-sub-tab a .ids-sub-tab-text span,
.ids-sub-tab a .ids-sub-tab-text .ids-text {
  display: inline-block;
}
.ids-sub-tab a .ids-sub-tab-text ::slotted(ids-text) {
  display: inline-block;
}
.ids-sub-tab a .ids-sub-tab-submenu-icon {
  margin-inline-start: 12px;
  grid-column-start: 3;
  transform: rotateZ(-90deg);
}
.ids-sub-tab .ids-sub-tab-text {
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ids-sub-tab:not(.text-center) .ids-sub-tab-text, .ids-sub-tab:not(.text-start) .ids-sub-tab-text, .ids-sub-tab:not(.text-end) .ids-sub-tab-text {
  text-align: start;
}
.ids-sub-tab.text-center a, .ids-sub-tab.text-start a, .ids-sub-tab.text-end a {
  display: flex;
  align-items: center;
}
.ids-sub-tab.text-center a .ids-sub-tab-text, .ids-sub-tab.text-start a .ids-sub-tab-text, .ids-sub-tab.text-end a .ids-sub-tab-text {
  margin-inline-start: var(--ids-space-xs);
}
.ids-sub-tab.text-center a {
  text-align: center;
  justify-content: center;
}
.ids-sub-tab.text-start a {
  text-align: start;
  justify-content: start;
}
.ids-sub-tab.text-end a {
  text-align: end;
  justify-content: end;
}
.ids-sub-tab.disabled {
  color: var(--ids-menu-item-color-text-disabled);
  cursor: default;
  pointer-events: none;
  user-select: none;
}
.ids-sub-tab.disabled a {
  color: inherit;
}
.ids-sub-tab.disabled ids-icon,
.ids-sub-tab.disabled .ids-icon {
  fill: var(--ids-menu-item-color-text-disabled);
}
.ids-sub-tab.hidden {
  display: none;
}
.ids-sub-tab.highlighted {
  background-color: var(--ids-menu-item-highlight-color);
}
.ids-sub-tab.has-shortcuts a {
  grid-template-columns: 0 minmax(100px, auto) 1fr;
}
.ids-sub-tab.has-icon a {
  padding-inline-start: var(--ids-space-xs);
  padding-inline-end: 14px;
  grid-template-columns: 30px auto;
}
.ids-sub-tab.has-shortcuts.has-icon a {
  grid-template-columns: 30px calc(50% - 15px) calc(50% - 15px);
}
.ids-sub-tab.has-checkmark a, .ids-sub-tab.has-multi-checkmark a {
  padding-inline-start: var(--ids-space-2xs);
  grid-template-columns: 30px 0 max-content 0;
}
.ids-sub-tab.has-checkmark a .check, .ids-sub-tab.has-multi-checkmark a .check {
  grid-column-start: 1;
}
.ids-sub-tab.has-checkmark a ids-icon,
.ids-sub-tab.has-checkmark a .ids-icon,
.ids-sub-tab.has-checkmark a .ids-sub-tab-display-icon, .ids-sub-tab.has-multi-checkmark a ids-icon,
.ids-sub-tab.has-multi-checkmark a .ids-icon,
.ids-sub-tab.has-multi-checkmark a .ids-sub-tab-display-icon {
  grid-column-start: 2;
}
.ids-sub-tab.has-checkmark a .ids-sub-tab-text, .ids-sub-tab.has-multi-checkmark a .ids-sub-tab-text {
  grid-column-start: 3;
}
.ids-sub-tab.has-checkmark a .ids-sub-tab-submenu-icon, .ids-sub-tab.has-multi-checkmark a .ids-sub-tab-submenu-icon {
  grid-column-start: 4;
}
.ids-sub-tab.has-checkmark .ids-sub-tab-submenu-icon, .ids-sub-tab.has-multi-checkmark .ids-sub-tab-submenu-icon {
  position: relative;
  inset-block-start: 3px;
  inset-inline-start: 8px;
}
.ids-sub-tab.has-shortcuts.has-checkmark a, .ids-sub-tab.has-shortcuts.has-multi-checkmark a {
  grid-template-columns: 30px 0 50% calc(50% - 30px);
}
.ids-sub-tab.has-submenu a {
  grid-template-columns: 0 calc(100% - 24px) 29px;
}
.ids-sub-tab.has-submenu .ids-sub-tab-shortcuts {
  display: none;
}
.ids-sub-tab.has-icon.has-checkmark a, .ids-sub-tab.has-icon.has-multi-checkmark a {
  padding-inline-start: 0;
  grid-template-columns: 30px 30px calc(100% - 60px);
  width: calc(100% - 12px);
}
.ids-sub-tab.has-icon.has-checkmark.align-icon-end a, .ids-sub-tab.has-icon.has-multi-checkmark.align-icon-end a {
  grid-template-columns: 30px calc(100% - 55px) 25px;
}
.ids-sub-tab.has-icon.has-checkmark.align-icon-end a .ids-sub-tab-text, .ids-sub-tab.has-icon.has-multi-checkmark.align-icon-end a .ids-sub-tab-text {
  grid-column-start: 2;
}
.ids-sub-tab.has-icon.has-checkmark.align-icon-end a .ids-sub-tab-icon, .ids-sub-tab.has-icon.has-multi-checkmark.align-icon-end a .ids-sub-tab-icon {
  grid-column-start: 3;
}
.ids-sub-tab.has-shortcuts.has-icon.has-checkmark a, .ids-sub-tab.has-shortcuts.has-icon.has-mutlt-checkmark a {
  grid-template-columns: 24px 30px calc(50% - 24px) calc(50% - 24px);
}
.ids-sub-tab.has-icon.has-submenu a {
  grid-template-columns: 30px calc(100% - 53px) 31px;
}
.ids-sub-tab.has-checkmark.has-submenu a, .ids-sub-tab.has-multi-checkmark.has-submenu a {
  grid-template-columns: 30px 0 calc(100% - 55px) 25px;
}
.ids-sub-tab.has-icon.has-checkmark.has-submenu a, .ids-sub-tab.has-icon.has-multi-checkmark.has-submenu a {
  grid-template-columns: 30px 30px calc(100% - 85px) 25px;
}
.ids-sub-tab:not(.inherit-color):not(.disabled) {
  color: var(--ids-menu-item-color-text-default);
}
.ids-sub-tab.inherit-color:not(.disabled) {
  color: inherit;
}
.ids-sub-tab.inherit-color:not(.disabled) a {
  color: inherit;
}
.ids-sub-tab.color-variant-module-nav {
  color: var(--ids-module-nav-settings-menu-item-text-color);
}
.ids-sub-tab.color-variant-module-nav a {
  padding-block: 10px;
}
.ids-sub-tab.color-variant-module-nav .ids-sub-tab-text {
  color: var(--ids-module-nav-settings-menu-item-text-color);
  padding-inline-start: var(--ids-module-nav-accordion-gutter-size);
}

.ids-sub-tab-shortcuts {
  pointer-events: none;
  text-align: end;
}

.has-checkmark span.check {
  position: relative;
}
.has-checkmark.selected span.check::after {
  position: absolute;
  border: 1px solid;
  transform: rotate(45deg);
  border-color: var(--ids-menu-check-color-default) var(--ids-menu-check-color-default) var(--ids-menu-check-color-default) transparent;
  border-width: 0 2px 2px 0;
  content: " ";
  height: 11px;
  width: 5px;
  left: 11px;
  margin-top: var(--ids-space-3xs);
}
.has-checkmark.selected.disabled span.check::after {
  border-color: var(--ids-menu-check-color-disabled) var(--ids-menu-check-color-disabled) var(--ids-menu-check-color-disabled) transparent;
}

.has-multi-checkmark span.check {
  position: absolute;
  border: var(--ids-checkbox-border);
  border-radius: var(--ids-checkbox-border-radius);
  height: 14px;
  width: 14px;
  left: 0;
  top: 3px;
  align-self: center;
  justify-self: center;
  position: relative;
  top: 0;
}
.has-multi-checkmark.disabled span.check {
  opacity: var(--ids-menu-color-disabled);
}
.has-multi-checkmark.selected span.check {
  background-color: var(--ids-checkbox-color-background-selected);
  border-color: var(--ids-checkbox-color-border-selected);
}
.has-multi-checkmark.selected span.check::after {
  position: absolute;
  display: block;
  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);
  border-width: var(--ids-checkbox-border-width-selected-after);
  animation: check 0.15s ease-out;
  transform: rotate(45deg);
  content: "";
  height: 10px;
  left: 4px;
  top: 0;
  width: 4px;
}
.has-multi-checkmark.disabled.selected span.check {
  background-color: var(--ids-checkbox-color-background-selected-disabled);
  border-color: var(--ids-checkbox-color-border-selected-disabled);
}

.ids-sub-tab[dir=rtl] a .ids-sub-tab-submenu-icon,
.ids-sub-tab.rtl a .ids-sub-tab-submenu-icon {
  grid-column-start: 3;
  transform: rotateZ(90deg);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-tabs/ids-sub-tab.scss","webpack://./src/components/ids-tabs/ids-sub-tabs-base.scss","webpack://./src/themes/mixins/ids-check-mixin.scss","webpack://./src/themes/mixins/ids-checkbox-mixin.scss"],"names":[],"mappings":"AAAA,0BAAA;ACAA;;EAAA;ACAA;;EAAA;ACAA;;EAAA;AAoIA;EACE;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,QAAA;EHzHF;EG4HA;IACE,SAAA;IACA,OAAA;IACA,QAAA;IACA,UAAA;EH1HF;EG6HA;IACE,YAAA;IACA,SAAA;IACA,MAAA;IACA,UAAA;EH3HF;AACF;AG8HA;EACE;IACE,QAAA;EH5HF;EG+HA;IACE,WAAA;EH7HF;AACF;AAhCA;;;;;;GAAA;AAOA;EACE,cAAA;EACA,gBAAA;AAkCF;AA9BE;EACE,aAAA;AAgCJ;;AA1BE;EACE,oBAAA;EACA,iBAAA;AA6BJ;;AAxBA;EACE,oBAAA;AA2BF;;AAvBA;EACE,sBAAA;AA0BF;;AAtBA;EACE,gBAAA;AAyBF;;AAtBA;EACE,aAAA;AAyBF;;AAtBA;EACE,mBAAA;EACA,eAAA;EACA,+EAAA;EACA,gBAAA;EACA,gBAAA;EACA,8DAAA;EACA,iBAAA;AAyBF;AAvBE;EACE,aAAA;AAyBJ;AAvBI;EACE,wBAAA;AAyBN;AArBE;;;EAGE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AAuBJ;AAlBE;EACE,0BAAA;EACA,uCAAA;EACA,2CAAA;EACA,aAAA;EACA,yCAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;AAoBJ;AAhBI;EACE,UAAA;AAkBN;AAfI;EACE,sBAAA;AAiBN;AAbI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAeN;AAZI;;;EAGE,oBAAA;AAcN;AAXI;EACE,oBAAA;AAaN;AAXM;;EAEE,qBAAA;AAaR;AAVM;EACE,qBAAA;AAYR;AARI;EACE,yBAAA;EACA,oBAAA;EACA,0BAAA;AAUN;AANE;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;AAQJ;AAFI;EACE,iBAAA;AAIN;AAGI;EACE,aAAA;EACA,mBAAA;AADN;AAGM;EACE,wCAAA;AADR;AAOI;EACE,kBAAA;EACA,uBAAA;AALN;AAUI;EACE,iBAAA;EACA,sBAAA;AARN;AAaI;EACE,eAAA;EACA,oBAAA;AAXN;AAiBE;EACE,+CAAA;EAGA,eAAA;EACA,oBAAA;EACA,iBAAA;AAjBJ;AAmBI;EACE,cAAA;AAjBN;AAoBI;;EAEE,8CAAA;AAlBN;AAyBE;EACE,aAAA;AAvBJ;AA6BE;EACE,sDAAA;AA3BJ;AAkCI;EACE,gDAAA;AAhCN;AAwCI;EACE,yCAAA;EACA,wBAAA;EACA,gCAAA;AAtCN;AA2CI;EACE,6DAAA;AAzCN;AAkDI;EACE,0CAAA;EACA,2CAAA;AAhDN;AAmDM;EACE,oBAAA;AAjDR;AAoDM;;;;;EAGE,oBAAA;AAhDR;AAmDM;EACE,oBAAA;AAjDR;AAoDM;EACE,oBAAA;AAlDR;AAsDI;EACE,kBAAA;EACA,sBAAA;EACA,uBAAA;AApDN;AA0DI;EACE,kDAAA;AAxDN;AAgEI;EACE,+CAAA;AA9DN;AAmEI;EACE,aAAA;AAjEN;AA0EI;EACE,uBAAA;EACA,kDAAA;EACA,wBAAA;AAxEN;AA8EI;EACE,kDAAA;AA5EN;AA8EM;EACE,oBAAA;AA5ER;AA+EM;EACE,oBAAA;AA7ER;AAoFI;EACE,kEAAA;AAlFN;AA2FI;EACE,kDAAA;AAzFN;AAgGI;EACE,oDAAA;AA9FN;AAuGI;EACE,uDAAA;AArGN;AA6GI;EACE,8CAAA;AA3GN;AAgHI;EACE,cAAA;AA9GN;AAgHM;EACE,cAAA;AA9GR;AAsHE;EACE,0DAAA;AApHJ;AAsHI;EACE,mBAAA;AApHN;AAuHI;EACE,0DAAA;EACA,iEAAA;AArHN;;AA0HA;EACE,oBAAA;EACA,eAAA;AAvHF;;AA8HE;EElZA,kBAAA;AFwRF;AA+HI;EElZF,kBAAA;EACA,iBAAA;EACA,wBAAA;EACA,qIAAA;EAIA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EF2YI,UAAA;EACA,gCAAA;AAvHN;AA2HM;EE1YJ,wIAAA;AFkRF;;AAgIE;EGraA,kBAAA;EACA,kCAAA;EACA,gDAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EHkaE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,MAAA;AAxHJ;AA2HE;EACE,uCAAA;AAzHJ;AA6HI;EGpaF,+DAAA;EACA,uDAAA;AH0SF;AA4HM;EGlaJ,kBAAA;EACA,cAAA;EACA,sFAAA;EACA,6DAAA;EACA,+BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,MAAA;EACA,UAAA;AHySF;AAuHM;EG7XJ,wEAAA;EACA,gEAAA;AHyQF;;AA6HE;;EACE,oBAAA;EACA,yBAAA;AAzHJ","sourcesContent":["/* Ids Sub Tab Component */\n@use './ids-sub-tabs-base' as *;\n@use '../../themes/mixins/ids-check-mixin' as *;\n@use '../../themes/mixins/ids-checkbox-mixin' as *;\n\n/**\n * NOTE ABOUT MENU ITEM ELEMENT ORDER:\n * Definitions for grid template size in IdsMenuItem are defined based on the below order.\n * If changes are made to IdsMenuItem's rendering, this order must remain in place.\n *\n * [checkmark?] - [icon?] - text - [shortcut text?] - [submenu icon?]\n **/\n:host {\n  display: block;\n  position: static;\n\n  // @TODO: remove slotted rules if we decide to\n  // support Submenus inside standalone ids-menu\n  ::slotted(ids-menu) {\n    display: none;\n  }\n}\n\n// override when ids menu item is being used in ids tab\n:host(.ids-tab-more-menu-item) {\n  div a .ids-sub-tab-text{\n    text-overflow: unset;\n    overflow: visible;\n  }\n}\n\n// Fixes usability issues with some slotted IDS components inside menu items\n::slotted(ids-text) {\n  pointer-events: none;\n}\n\n// For menu items including a close button, shift by 1px for alignment's sake\n::slotted(ids-icon[icon=\"close\"]) {\n  inset-block-start: 1px;\n}\n\n// Resets position rules for nested menus\n::slotted(ids-popup-menu) {\n  position: static;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n.ids-sub-tab {\n  align-items: center;\n  cursor: pointer;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  list-style: none;\n  position: static;\n  transition: background-color 50ms cubic-bezier(0.4, 0, 0.6, 1);\n  user-select: none;\n\n  &.dismissible {\n    display: flex;\n\n    a {\n      width: calc(100% - 32px);\n    }\n  }\n\n  ids-icon,\n  .ids-icon,\n  .ids-sub-tab-display-icon {\n    display: block;\n    align-self: center;\n    justify-content: center;\n    place-self: inherit;\n  }\n\n  // ================================================\n  // Standard Rules for a menu item with no icons\n  a {\n    padding-inline-start: 12px;\n    padding-inline-end: var(--ids-space-xs);\n    padding-block: var(--ids-menu-item-padding);\n    display: grid;\n    font-size: var(--ids-menu-item-font-size);\n    grid-template-columns: 0 auto;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    user-select: inherit;\n    white-space: nowrap;\n\n    // Disable default browser focus state.\n    // (comment this out to debug the true menu focus state)\n    &:focus {\n      outline: 0;\n    }\n\n    > * {\n      vertical-align: middle;\n    }\n\n    // Wraps slotted icons inside menu items and needs its own centering rules\n    .ids-sub-tab-icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    ids-icon,\n    .ids-icon,\n    .ids-sub-tab-display-icon {\n      grid-column-start: 1;\n    }\n\n    .ids-sub-tab-text {\n      grid-column-start: 2;\n\n      span,\n      .ids-text {\n        display: inline-block;\n      }\n\n      ::slotted(ids-text) {\n        display: inline-block;\n      }\n    }\n\n    .ids-sub-tab-submenu-icon {\n      margin-inline-start: 12px;\n      grid-column-start: 3;\n      transform: rotateZ(-90deg);\n    }\n  }\n\n  .ids-sub-tab-text {\n    white-space: nowrap;\n    display: block;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  &:not(.text-center),\n  &:not(.text-start),\n  &:not(.text-end) {\n    .ids-sub-tab-text {\n      text-align: start;\n    }\n  }\n\n  &.text-center,\n  &.text-start,\n  &.text-end {\n    a {\n      display: flex;\n      align-items: center;\n\n      .ids-sub-tab-text {\n        margin-inline-start: var(--ids-space-xs);\n      }\n    }\n  }\n\n  &.text-center {\n    a {\n      text-align: center;\n      justify-content: center;\n    }\n  }\n\n  &.text-start {\n    a {\n      text-align: start;\n      justify-content: start;\n    }\n  }\n\n  &.text-end {\n    a {\n      text-align: end;\n      justify-content: end;\n    }\n  }\n\n  // ================================================\n  // Disabled state\n  &.disabled {\n    color: var(--ids-menu-item-color-text-disabled);\n\n    // Disable all mouse interactions\n    cursor: default;\n    pointer-events: none;\n    user-select: none;\n\n    a {\n      color: inherit;\n    }\n\n    ids-icon,\n    .ids-icon {\n      fill: var(--ids-menu-item-color-text-disabled);\n    }\n  }\n\n  // ================================================\n  // Hidden state\n\n  &.hidden {\n    display: none;\n  }\n\n  // ================================================\n  // Highlighted state\n\n  &.highlighted {\n    background-color: var(--ids-menu-item-highlight-color);\n  }\n\n  // ================================================\n  // Rules for a menu item with shortcut keys\n\n  &.has-shortcuts {\n    a {\n      grid-template-columns: 0 minmax(100px, auto) 1fr;\n    }\n  }\n\n  // ================================================\n  // Rules for a menu item with an icon\n\n  &.has-icon {\n    a {\n      padding-inline-start: var(--ids-space-xs);\n      padding-inline-end: 14px;\n      grid-template-columns: 30px auto;\n    }\n  }\n\n  &.has-shortcuts.has-icon {\n    a {\n      grid-template-columns: 30px calc(50% - 15px) calc(50% - 15px);\n    }\n  }\n\n  // ================================================\n  // Rules for a menu item with a checkmark\n\n  &.has-checkmark,\n  &.has-multi-checkmark {\n    a {\n      padding-inline-start: var(--ids-space-2xs);\n      grid-template-columns: 30px 0 max-content 0;\n\n      // When checkmarks are present, all column placements change\n      .check {\n        grid-column-start: 1;\n      }\n\n      ids-icon,\n      .ids-icon,\n      .ids-sub-tab-display-icon {\n        grid-column-start: 2;\n      }\n\n      .ids-sub-tab-text {\n        grid-column-start: 3;\n      }\n\n      .ids-sub-tab-submenu-icon {\n        grid-column-start: 4;\n      }\n    }\n\n    .ids-sub-tab-submenu-icon {\n      position: relative;\n      inset-block-start: 3px;\n      inset-inline-start: 8px;\n    }\n  }\n\n  &.has-shortcuts.has-checkmark,\n  &.has-shortcuts.has-multi-checkmark {\n    a {\n      grid-template-columns: 30px 0 50% calc(50% - 30px);\n    }\n  }\n\n  // ================================================\n  // Rules for a menu item with a submenu + submenu icon\n\n  &.has-submenu {\n    a {\n      grid-template-columns: 0 calc(100% - 24px) 29px;\n    }\n\n    // NOTE: Submenu items contain this element,\n    // but hide it from the grid template calculation\n    .ids-sub-tab-shortcuts {\n      display: none;\n    }\n  }\n\n  // ================================================\n  // Rules for a menu item with a checkmark\n\n  &.has-icon.has-checkmark,\n  &.has-icon.has-multi-checkmark {\n    a {\n      padding-inline-start: 0;\n      grid-template-columns: 30px 30px calc(100% - 60px);\n      width: calc(100% - 12px);\n    }\n  }\n\n  &.has-icon.has-checkmark.align-icon-end,\n  &.has-icon.has-multi-checkmark.align-icon-end {\n    a {\n      grid-template-columns: 30px calc(100% - 55px) 25px;\n\n      .ids-sub-tab-text {\n        grid-column-start: 2;\n      }\n\n      .ids-sub-tab-icon {\n        grid-column-start: 3;\n      }\n    }\n  }\n\n  &.has-shortcuts.has-icon.has-checkmark,\n  &.has-shortcuts.has-icon.has-mutlt-checkmark {\n    a {\n      grid-template-columns: 24px 30px calc(50% - 24px) calc(50% - 24px);\n    }\n  }\n\n  // ================================================\n  // Rules for a menu item with an action-defined icon, and a submenu + submenu icon\n  // Also for a menu item with a checkmark, and a submenu + submenu icon\n\n  &.has-icon.has-submenu {\n    a {\n      grid-template-columns: 30px calc(100% - 53px) 31px;\n    }\n  }\n\n  // Icon slot is still present (but hidden) in this configuration\n  &.has-checkmark.has-submenu,\n  &.has-multi-checkmark.has-submenu {\n    a {\n      grid-template-columns: 30px 0 calc(100% - 55px) 25px;\n    }\n  }\n\n  // ================================================\n  // Rules for a menu item with a checkmark, action-defined icon, and a submenu + submenu icon\n\n  &.has-icon.has-checkmark.has-submenu,\n  &.has-icon.has-multi-checkmark.has-submenu {\n    a {\n      grid-template-columns: 30px 30px calc(100% - 85px) 25px;\n    }\n  }\n\n  // ================================================\n  // Inherits a text color from a containing element\n\n  &:not(.inherit-color) {\n    &:not(.disabled) {\n      color: var(--ids-menu-item-color-text-default);\n    }\n  }\n\n  &.inherit-color {\n    &:not(.disabled) {\n      color: inherit;\n\n      a {\n        color: inherit;\n      }\n    }\n  }\n\n  // ================================================\n  // Color Variant: Module Nav\n\n  &.color-variant-module-nav {\n    color: var(--ids-module-nav-settings-menu-item-text-color);\n\n    a {\n      padding-block: 10px;\n    }\n\n    .ids-sub-tab-text {\n      color: var(--ids-module-nav-settings-menu-item-text-color);\n      padding-inline-start: var(--ids-module-nav-accordion-gutter-size);\n    }\n  }\n}\n\n.ids-sub-tab-shortcuts {\n  pointer-events: none;\n  text-align: end;\n}\n\n// ===============================================\n// Checkmark Styles\n\n.has-checkmark {\n  span.check {\n    @include check-base();\n  }\n\n  &.selected {\n    span.check::after {\n      @include check-icon();\n\n      left: 11px;\n      margin-top: var(--ids-space-3xs);\n    }\n\n    &.disabled {\n      span.check::after {\n        @include check-icon-disabled();\n      }\n    }\n  }\n}\n\n.has-multi-checkmark {\n  span.check {\n    @include checkbox-unchecked();\n\n    align-self: center;\n    justify-self: center;\n    position: relative;\n    top: 0;\n  }\n\n  &.disabled span.check  {\n    opacity: var(--ids-menu-color-disabled);\n  }\n\n  &.selected {\n    span.check {\n      @include checkbox-checked();\n\n      &::after {\n        @include checkbox-checked-after();\n      }\n    }\n  }\n\n  &.disabled {\n    &.selected {\n      span.check {\n        @include checkbox-disabled-checked();\n      }\n    }\n  }\n}\n\n// RTL Fixes\n.ids-sub-tab[dir='rtl'],\n.ids-sub-tab.rtl {\n  a .ids-sub-tab-submenu-icon {\n    grid-column-start: 3;\n    transform: rotateZ(90deg);\n  }\n}\n","/**\n * Base Styles/Mixins for Ids Sub Tabs Component and all subcomponents.\n */\n// Resets the User-Agent stylesheet rules for `<ul>` in Chrome\n@mixin reset-menu-style() {\n  display: block;\n  margin-block-end: 0;\n  margin-block-start: 0;\n  padding-inline-start: 0;\n}\n","/**\n * Single Checkmark Mixin\n */\n\n// Use this on an element that serves as a checkmark container\n@mixin check-base() {\n  position: relative;\n}\n\n// Use this on that same element's `::after` pseudo-element\n@mixin check-icon() {\n  position: absolute;\n  border: 1px solid;\n  transform: rotate(45deg);\n  border-color: var(--ids-menu-check-color-default)\n    var(--ids-menu-check-color-default)\n    var(--ids-menu-check-color-default)\n    transparent;\n  border-width: 0 2px 2px 0;\n  content: ' ';\n  height: 11px;\n  width: 5px;\n}\n\n// Use this on top of the above definition,\n// for situations where this checkmark can appear to be \"disabled\"\n@mixin check-icon-disabled() {\n  border-color: var(--ids-menu-check-color-disabled)\n    var(--ids-menu-check-color-disabled)\n    var(--ids-menu-check-color-disabled)\n    transparent;\n}\n","/**\n * Checkbox Mixins.\n */\n@use 'sass:list';\n@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n// Unchecked\n@mixin checkbox-unchecked() {\n  position: absolute;\n  border: var(--ids-checkbox-border);\n  border-radius: var(--ids-checkbox-border-radius);\n  height: 14px;\n  width: 14px;\n  left: 0;\n  top: 3px;\n}\n\n@mixin checkbox-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-error);\n}\n\n// Checked\n@mixin checkbox-checked() {\n  background-color: var(--ids-checkbox-color-background-selected);\n  border-color: var(--ids-checkbox-color-border-selected);\n}\n\n@mixin checkbox-checked-after {\n  position: absolute;\n  display: block;\n  border: var(--ids-font-size-2xs) solid var(--ids-checkbox-color-border-selected-after);\n  border-width: var(--ids-checkbox-border-width-selected-after);\n  animation: check 0.15s ease-out;\n  transform: rotate(45deg);\n  content: '';\n  height: 10px;\n  left: 4px;\n  top: 0;\n  width: 4px;\n}\n\n// Indeterminate\n@mixin checkbox-indeterminate() {\n  background-color: var(--ids-checkbox-color-background-indeterminate);\n  border-color: var(--ids-checkbox-color-border-indeterminate);\n}\n\n@mixin checkbox-indeterminate-after {\n  position: absolute;\n  animation: checkindeterminate 0.15s ease-out;\n  display: block;\n  border: 1px solid var(--ids-checkbox-color-border-indeterminate-after);\n  border-width: var(--ids-checkbox-border-width-indeterminate);\n  content: '';\n  height: 6px;\n  left: 2px;\n  top: 0;\n  transform: none;\n  width: 10px;\n}\n\n// Disabled\n@mixin checkbox-disabled-unchecked {\n  background-color: var(--ids-checkbox-color-background-disabled);\n  border-color: var(--ids-checkbox-color-border-disabled);\n  cursor: var(--ids-cursor-default);\n}\n\n@mixin checkbox-disabled-unchecked-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n}\n\n@mixin checkbox-disabled-checked() {\n  background-color: var(--ids-checkbox-color-background-selected-disabled);\n  border-color: var(--ids-checkbox-color-border-selected-disabled);\n}\n\n@mixin checkbox-disabled-text {\n  cursor: var(--ids-cursor-default);\n  color: var(--ids-checkbox-color-text-disabled);\n}\n\n// Focus\n@mixin checkbox-focus {\n  border-color: var(--ids-checkbox-color-border-focus);\n  box-shadow: var(--ids-checkbox-shadow-focus);\n}\n\n@mixin checkbox-focus-error {\n  border-color: var(--ids-checkbox-color-border-focus-error);\n  box-shadow: var(--ids-checkbox-shadow-focus-error);\n}\n\n// Colored\n$color-names: 'green' 'purple' 'blue' 'orange' 'red';\n$color-vars: --ids-color-green-70 --ids-color-purple-70 --ids-color-blue-70 --ids-color-orange-70 --ids-color-red-70;\n\n@mixin checkbox-colored() {\n  @each $name in $color-names {\n    $i: list.index($color-names, $name);\n    $color: var(#{list.nth($color-vars, $i)});\n\n    &[color='#{$name}'] input[type='checkbox'] {\n      ~ .checkmark {\n        @include checkbox-colored-box($color);\n      }\n\n      &:disabled ~ .checkmark {\n        @include checkbox-disabled-unchecked();\n      }\n\n      &:disabled:checked ~ .checkmark {\n        @include checkbox-disabled-checked();\n      }\n\n      &:focus ~ .checkmark {\n        @include checkbox-colored-box-focus($color);\n      }\n    }\n  }\n}\n\n@mixin checkbox-colored-box($color) {\n  background-color: $color;\n  border-color: $color;\n}\n\n@mixin checkbox-colored-box-focus($color) {\n  border-color: $color;\n}\n\n// Animations\n@keyframes check {\n  0% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 0;\n  }\n\n  50% {\n    height: 0;\n    left: 0;\n    top: 8px;\n    width: 4px;\n  }\n\n  100% {\n    height: 10px;\n    left: 4px;\n    top: 0;\n    width: 4px;\n  }\n}\n\n@keyframes checkindeterminate {\n  0% {\n    width: 0;\n  }\n\n  100% {\n    width: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
